<template>
  <div class="d-flex flex-column justify-space-between fill-height">
    <v-sheet color="transparent" height="48"></v-sheet>
    <v-row>
      <v-col cols="12" style="min-height: 68px" v-if="error">
        <LoginError :error="error" />
      </v-col>
    </v-row>
    <v-sheet height="48"></v-sheet>

    <v-row no-gutters :style="!error ? 'height: calc(100% - 68px - 68px)' : 'height: calc(100% - 68px)'">
      <v-col cols="12">
        <v-form v-model="valid" @submit.prevent>
          <v-text-field
            autofocus
            placeholder="Email address"
            persistent-placeholder
            variant="underlined"
            v-model="username"
            @update:modelValue="clearError"
            :rules="[v => !!v && v.length && v.includes('@') || 'Please enter a valid email address']"
            autocomplete="username"
            @keydown.enter="checkEmail(username)"
          />
        </v-form>
      </v-col>
      <v-col cols="12" class="d-flex justify-center mb-4">
        <v-btn width="95" @click.prevent="checkEmail(username)" color="primary" :disabled="!username || !valid || loading" :loading="loading" class="text-none">Log in</v-btn>
      </v-col>

    </v-row>

  </div>

</template>

<script lang="ts">
import {Component, Vue, toNative, Prop, Watch, Emit} from "vue-facing-decorator";
import ActionButton from "@/components/ActionButton.vue";
import LoginError from "@/components/LoginError.vue";
@Component({
  components: {LoginError, ActionButton}
})
export default class EmailPrompt extends Vue {
  @Prop() private queryUsername!: string;
  @Prop() private error!: string;
  @Prop() private loading!: boolean;
  private username = '';
  private valid = false;

  @Emit()
  private clearError() {
    return true;
  }
  @Emit()
  private checkEmail(username: string): string {
    return username;
  }
  @Watch('queryUsername', {immediate: true})
  private onQueryParamUpdate()  {
    this.username = this.queryUsername;
  }
}
</script>